module.exports = __webpack_public_path__ + "static/media/success.ede33a19.svg";